import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from '@/App';
import { AppProviders } from '@/providers/AppProviders';
import '@/index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root was not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    {/* NAVIGATION IS A TRANSITION. Without it a click on a page whose chunk has
        not arrived suspended the router synchronously, and React swapped the
        WHOLE app for the nearest fallback - a full-screen skeleton that
        unmounted the shell and everything alive in it. As a transition React
        keeps the current screen up until the next one is ready. */}
    <BrowserRouter future={{ v7_startTransition: true }}>
      <AppProviders>
        <App />
      </AppProviders>
    </BrowserRouter>
  </StrictMode>,
);
